<template>
  <div id="layout">
    <MenuSuperiorComponent />
    <div id="content">
      <div
        id="alertas"
        v-if="mostrarNotificacao"
      >
        <v-alert
          closable
          icon="$info"
          color="warning"
          :title="notificacaoAtual?.titulo"
          density="compact"
          variant="flat"
          :text="notificacaoAtual?.conteudo"
          @click="redirecionamento"
          @click:close.stop="mostrarNotificacao = false"
        >
        </v-alert>
      </div>
      <AjudaComponent />
      <router-view />
    </div>
    <FooterComponent />
  </div>
</template>

<script>
import MenuSuperiorComponent from "@/components/layout/MenuSuperiorComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import {
  iniciarTimerRenovacaoToken,
  pararTimer,
} from "@/utils/timerTokenRefresh";
import { getRefreshToken } from "@/utils/tokenService";
import usuariosService from "@/service/usuariosService";
import AjudaIconComponent from "@/components/common/AjudaIconComponent.vue";

export default {
  data() {
    return {
      mostrarNotificacao: false,
      notificacoes: {
        notificacaoAtualizarPerfil: {
          titulo: "Cadastro incompleto",
          conteudo:
            "Faltam algumas informações no seu perfil. Toque aqui para completar.",
          urlRedirecionamento: "/perfil",
        },
      },
      notificacaoAtual: null,
    };
  },
  components: {
    MenuSuperiorComponent,
    FooterComponent,
    AjudaComponent: AjudaIconComponent,
  },
  async mounted() {
    this.gerenciarSessao();
    const refreshToken = getRefreshToken();
    if (refreshToken && this.$route.path !== "/login") {
      await this.getNotificacao();
    }
  },
  beforeUnmount() {
    pararTimer(); // Limpa ao destruir o componente
  },
  methods: {
    gerenciarSessao() {
      const refreshToken = getRefreshToken();
      if (refreshToken && this.$route.path !== "/login") {
        iniciarTimerRenovacaoToken();
      }
    },
    redirecionamento() {
      this.$router.push(this.notificacaoAtual.urlRedirecionamento);
      this.mostrarNotificacao = false;
    },
    async getNotificacao() {
      const response = await usuariosService.notificacaoAtualizarPerfil();

      if (response) {
        this.notificacaoAtual = {
          ...this.notificacoes.notificacaoAtualizarPerfil,
        };
        this.mostrarNotificacao = true;
      }
    },
  },
  watch: {
    // Caso a rota mude para login, para o timer
    "$route.path"(newPath) {
      if (newPath === "/login") pararTimer();
    },
  },
};
</script>

<style scoped>
#layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

#content {
  flex: 1;
  padding: 20px 60px;
  background-color: white;
  overflow-y: auto;
}

#alertas {
  position: fixed;
  right: 1%;
  max-width: 600px;
  z-index: 999;
  cursor: pointer;
}
@media (max-width: 768px) {
  #content {
    flex: 1;
    padding: 0.5rem 0.8rem;
    background-color: white;
    overflow-y: auto;
  }
}
</style>
